//Accordion section
(function($) { "use strict";


	var $accordion = $('.section-accordion');
		
	// check page contains element
	if( $accordion.length ) {

		$accordion.each(function () {
			$(this).find('.accordion__title').on('click', function(){
				//expand accordion
				$(this)
					.closest('li')
					.toggleClass('js-is-open')
					.find('.accordion__content')
					.toggleClass('js-hidden');
			});
		});
	}



})(jQuery);